<script setup lang="ts">
import type { InvestigationCollectionItem } from '@nuxt/content'

const props = defineProps<{
  article: InvestigationCollectionItem
}>()

const route = useRoute('onderzoek-slug-hoofdstukken-chapterName___nl')

const { data: surround } = await useAsyncData(`${route.path}-surround`, () => {
  return queryCollectionItemSurroundings('investigationChapter', route.path, {
    fields: ['description'],
  }).where('PATH', 'LIKE', `%${props.article.path}%`)
})
</script>

<template>
  <UContentSurround :surround="(surround as any)" />
</template>
